import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { subscriptionActions } from "../redux/subscription-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";

const useSubscription = () => {
   const { sendRequest } = useHttps();
   const dispatch = useDispatch();
   const { apiErrorReportingService } = useReporting();

   const getSubcriptionsSuccess = (data) => {
      dispatch(subscriptionActions.setSubscriptionResponse(data?.data));
   };

   const getSubscriptionLoaderFunc = (value) => {
      dispatch(subscriptionActions.setGetLoading(value));
   };

   const toggleEnableUser = (userDetails) => {
      const body = {
         byAdmin: true,
         email: userDetails.username,
         enableUserAccount: !userDetails.enabled,
      };
      const config = {
         method: "put",
         url: `user/edit-profile`,
         data: body,
      };

      sendRequest(
         config,
         getSubscriptions,
         getSubscriptionLoaderFunc,
         apiErrorReportingService
      );
   };

   const toggleLockUser = (userDetails) => {
      const body = {
         byAdmin: true,
         email: userDetails.username,
         lockUserAccount: !userDetails.accountNonLocked,
      };
      const config = {
         method: "put",
         url: `user/edit-profile`,
         data: body,
      };

      sendRequest(
         config,
         getSubscriptions,
         getSubscriptionLoaderFunc,
         apiErrorReportingService
      );
   };

   const searchSubscription = (value) => {
      const searchValue = value ? `userDetails.fullName:${value.trim()}*` : "";

      getSubscriptions({ pageSize: 10, pageNo: 0, search: searchValue });
   };

   const getSubcriptionError = (error) => {
      apiErrorReportingService(error);
      dispatch(subscriptionActions.setSubscriptionResponse({}));
   };
   const getSubscriptions = useCallback(
      ({ pageSize = 10, pageNo = 0, sortBy = "id", search = "" }) => {
         const config = {
            method: "get",
            url: `user/get-all-subscribers?pageSize=${pageSize}&pageNo=${pageNo}&sortBy=${sortBy}&search=${search}`,
         };

         sendRequest(
            config,
            getSubcriptionsSuccess,
            getSubscriptionLoaderFunc,
            getSubcriptionError
         );
      },
      [sendRequest]
   );

   return {
      getSubscriptions,
      toggleLockUser,
      searchSubscription,
      toggleEnableUser,
   };
};

export default useSubscription;
